import Layout from './modules/Layout.js';
import Search from './modules/Search.js';

new Layout('home-page');
new Search();
